'use strict';

const jQuery = require('jquery');

const Mediator = require('./../../../core/mediator');
const Translator = require('./../../../core/translator');
const Container = require('./../../../core/container');

const Loader = require('./../../../services/loader');
const PopinManager = require('./../../../services/popin');

const Dropzone = require('./../service/dropzone');

const ContentManager = require('./../component/ContentManager');
const SaveManager = require('./../component/SaveManager');
const Uploader = require('./../service/uploader');
const FormatBytes = require('./../service/formatBytes');

require('./../../../services/tagChecker');

module.exports.updateFileOfMedia = (media, uploadData) => {
  let dfd = jQuery.Deferred();
  let elementName = media.getProperties('file_element');

  media.getData().done(() => {
    let elementData = media.data.elements[elementName];

    if (!elementData) {
      throw new Error(`Element ${elementName} doesnt exist for this media`);
    }

    ContentManager.createElement(elementData.type, {
      elements: {
        path: uploadData.path,
        originalname: uploadData.originalname,
      },
    }).done((element) => {
      media.addElement(elementName, {
        type: element.type,
        uid: element.uid,
      });

      dfd.resolve(media);
    });
  });

  return dfd.promise();
};

const createMediaPopin = (config = {}) => {
  let popinConfig = {
    'title': Translator.translate('my_image'),
    'classes': {
      'ui-dialog': 'cloud-dialog no-scroll with-btnClose',
    },

    'width': jQuery(window).width() / 2,
    'height': jQuery(window).height() - 150,
    'buttons': [
      {
        class: 'popin py-4 mt-3',
        text: Translator.translate('discard'),
        click: function() {
          popin.hide();
        },
      },
    ],
  };

  let $container = jQuery('<form />');
  let $menu = jQuery(`
        <ul class="upload-menu nav nav-tabs cursor-pointer">
            <li class="nav-item active" data-tab="computer">
                <span class="nav-link">${Translator.translate('my_computer')}</span>
            </li>
        </ul>`,
  );

  $menu.on('click', 'li', function() {
    $menu.find('li').removeClass('active');
    jQuery(this).addClass('active');

    $container.find('.tab').addClass('d-none');
    $container.find(`.tab-${jQuery(this).attr('data-tab')}`).removeClass('d-none');
  });

  $container.append($menu);

  let eventPopinConfigData = {popinConfig};
  Mediator.publish('before:plugin:upload:build-popin', eventPopinConfigData);

  let popin = PopinManager.createPopin(eventPopinConfigData.popinConfig);

  let $tpl = $container.append(jQuery('<div class="tab-wrapper" />').append(Dropzone.create({
    'classes': 'cloud-dropzone-outline tab tab-computer',
    'accepted_files': config.acceptedFiles,
    'label': config.isImage ? 'drop_image_label' : null,
    'label_size': config.isImage ? Translator.translate('drop_image_size', {'size': FormatBytes.format(Container.get('$toolbar').data('maxSize'))}) : null,
    'icon': config.isImage ? 'icon-image' : null,
    'onChange': function(file) {
      Loader.start(popin.rootElement);

      config.onChange(file).then(() => {
        popin.hide();
      }).catch(function() {
        Loader.stop(popin.rootElement);
      });
    },
  })));

  let data = {$tpl, content: config.content, popin, onMediaClick: config.onMediaClick};
  Mediator.publish('before:plugin:upload:render', data);

  if (Container.get('$toolbar').attr('data-upload-image-source') === 'media-center-only') {
    $menu.find('li:first').remove();
    $menu.find('li').click();
  }

  popin.setContent(data.$tpl);

  popin.display();
};

module.exports.createMediaPopin = createMediaPopin;

module.exports.onClick = (content) => {
  let elementName = content.getProperties('file_element');
  let isImage = content.getProperties('is_image');

  if (!elementName || !Container.get('isAllowedTo')('EDIT_CONTENT')) {
    return;
  }

  createMediaPopin({
    isImage,
    content,
    onChange: (file) => {
      return new Promise((resolve, reject) => {
        Uploader.imageIsValid(file, isImage).done(function() {
          Uploader.upload(file, {content}).done(function(response) {
            module.exports.updateFileOfMedia(content, response).done(() => {
              SaveManager.save().done(() => {
                content.refresh().done(() => {
                  Mediator.publish('after:upload', content);
                  Loader.stop(content.$);
                  resolve();
                });
              });
            });
          });
        }).fail(function() {
          Loader.stop(content.$);
          reject();
        });
      });
    },
  });
};
